import { Col, Row } from "react-bootstrap";
import type { RangeOption } from "../../../constants/epicLeaderboard";
import type { PkOpponents, PkPartner } from "../../../types/playerPk";
import { playerPath } from "../../../utils/playerLink";
import RankedBars from "./RankedBars";
import "./pk.css";

type Props = {
  opponents: PkOpponents;
  range: RangeOption;
};

// Top 10 victims and top 10 killers of the player, side by side.
const KillLists = ({ opponents, range }: Props) => {
  const toItems = (list: PkPartner[]) =>
    list.map((p) => ({
      label: p.player,
      count: p.count,
      to: playerPath({ player: p.player, range, tab: "pk" })
    }));

  return (
    <Row className="g-3 mb-3">
      <Col xs={12} md={6}>
        <div className="pk-card">
          <div className="pk-subtitle">Most killed</div>
          <RankedBars
            items={toItems(opponents.mostKilled)}
            color="#5fd38d"
            emptyText="No kills in this range."
          />
        </div>
      </Col>
      <Col xs={12} md={6}>
        <div className="pk-card">
          <div className="pk-subtitle">Most killed by</div>
          <RankedBars
            items={toItems(opponents.mostKilledBy)}
            color="#ff7b8f"
            emptyText="No deaths in this range."
          />
        </div>
      </Col>
    </Row>
  );
};

export default KillLists;
